import React, { useEffect, useState } from 'react';
import { Volume2, X } from 'lucide-react';
import {
    hasSoundConsent,
    grantSoundConsent,
    isSoundEnabled,
    setSoundEnabled,
    playOrderNew,
} from '../lib/notificationSounds';

// Admin-only banner — mounted in RestaurantLayout, never in ClientMenu, so
// customers scanning the QR code never see this. Shown once per browser,
// the first time a staff member lands on an admin page.
export function SoundConsentBanner() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (hasSoundConsent()) return;
        const t = setTimeout(() => setVisible(true), 500);
        return () => clearTimeout(t);
    }, []);

    const enable = () => {
        grantSoundConsent();
        if (!isSoundEnabled()) setSoundEnabled(true);
        setTimeout(() => playOrderNew({ force: true }), 100);
        setVisible(false);
    };

    const dismiss = () => {
        // Save consent so we don't re-prompt, but leave sounds disabled.
        grantSoundConsent();
        setSoundEnabled(false);
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div
            role="dialog"
            aria-label="Activează sunete notificare"
            style={{
                position: 'fixed',
                left: 12, right: 12,
                bottom: 'max(12px, env(safe-area-inset-bottom, 0px))',
                zIndex: 999,
                maxWidth: 520,
                margin: '0 auto',
                padding: '0.85rem 1rem',
                background: 'rgba(15, 20, 24, 0.97)',
                backdropFilter: 'blur(14px)',
                border: '1px solid var(--border-strong)',
                borderRadius: 14,
                boxShadow: '0 12px 36px rgba(0, 0, 0, 0.55)',
                color: 'var(--text)',
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                fontSize: '0.88rem',
                lineHeight: 1.4,
            }}
        >
            <div style={{ flexShrink: 0, color: 'var(--amber)' }}>
                <Volume2 size={22} />
            </div>
            <div style={{ flex: 1, color: 'var(--text-muted)' }}>
                Activează <strong style={{ color: 'var(--text)' }}>sunetele de notificare</strong> ca să auzi
                comenzile noi, chemările la masă și cererile de notă chiar dacă nu ești cu ochii pe ecran.
            </div>
            <button
                type="button"
                onClick={enable}
                className="btn btn-primary btn-sm"
                style={{ flexShrink: 0, whiteSpace: 'nowrap' }}
            >
                Activează
            </button>
            <button
                type="button"
                onClick={dismiss}
                aria-label="Închide"
                style={{
                    flexShrink: 0,
                    background: 'transparent',
                    border: 'none',
                    color: 'var(--text-faint)',
                    cursor: 'pointer',
                    padding: 4,
                    display: 'inline-flex',
                }}
            >
                <X size={16} />
            </button>
        </div>
    );
}
